import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TicketsApiService {
  constructor(private http: HttpClient) {
  }

  getTicket(ticketId: number): Observable<any> {
    return this.http.get('/helpdesk/global_problems', {
      params: { hd_ticket_number: String(ticketId) }
    });
  }
}
